module.exports = __webpack_public_path__ + "media/components/web/pages/static_pages/resources/not_found_image_mobile-dafd9419b2f68269602fed7934696d03.svg";